<template>
  <div class="wrapper">
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-form-item label="标题">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.title"
            clearable
          />
        </el-form-item>
        <el-form-item label="摘要">
          <el-input
            placeholder="请输入内容"
            v-model="searchData.zhaiyao"
            clearable
          />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="searchData.type" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-form-item>
            <el-button
              size="mini"
              style="width: 90px; margin-left: 50px"
              type="primary"
              @click="addGoods"
              >添加</el-button
            >
            <el-button
              size="mini"
              style="width: 90px"
              type="primary"
              @click="getList"
              >查询</el-button
            >
            <el-button size="mini" type="primary" @click="clearList"
              >清空查询条件</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          width="200"
        ></el-table-column>
        <!-- <el-table-column
          prop="zhaiyao"
          label="摘要"
          align="center"
          width="120"
        ></el-table-column> -->
        <el-table-column label="链接" width="120px">
          <template slot-scope="{ row }">
            <!-- <span class="link_text">{{ 'https://www.weiguanzixun.com/share?id='+row.id }}</span> -->
            <el-button
              @click="copy"
              size="mini"
              type="primary"
              class="btns"
              :data-clipboard-text="
                'https://www.weiguanzixun.com/broadcast?id=' + row.id
              "
              >复制</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="watchCount"
          label="浏览量"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="时间"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="coverImg"
          label="封面图"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <viewer>
              <img
                :src="row.coverImg"
                alt=""
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">图文直播</span>
            <span v-if="row.type == 0">党建</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="detailSpu(row)"
                >详情</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeSpu(row)"
                >修改</el-button
              >
                <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="success"
                v-if="row.deleteStatus == 0"
                @click="shelves(row, 1)"
                >上线</el-button
              >

              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="warning"
                @click="shelves(row, 0)"
                v-if="row.deleteStatus == 1"
                >下线</el-button
              >
              <!-- <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="deleteRow(row, 1)"
                >删除</el-button
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>

    <!-- 详情页面 -->
    <a-drawer
      title="详情"
      :width="1300"
      :visible="detailVisibile"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Detail :Detaildata="detailData" />
    </a-drawer>

    <!-- 修改页面 -->
    <a-drawer
      title="修改"
      :width="1300"
      :visible="changeVisibile"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Change :Changedata="changeData" />
    </a-drawer>
    <!-- 删除弹出框 -->
    <!-- <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal> -->
  </div>
</template>
<script>
import Detail from "./detail";
import Change from "./change";
import Clipboard from "clipboard";
export default {
  components: {
    Detail,
    Change,
  },
  data() {
    return {
      list: [],
      delOpen: false,
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      detailVisibile: false,
      changeVisibile: false,
      detailData: [],
      changeData: [],
      bid: "",
      searchData: {
        type: "",
        title: "",
        zhaiyao: "",
      },
      options: [
        {
          value: "0",
          label: "党建",
        },
        {
          value: "1",
          label: "直播图文",
        },
      ],
    };
  },
  methods: {
    addGoods() {
      this.$router.push("/addBroadCast");
    },
    // 修改spu
    changeSpu(row) {
      this.changeVisibile = true;
      this.changeData = row;
    },
    // 详情
    detailSpu(row) {
      this.detailVisibile = true;
      this.detailData = row;
    },
     // 上架下架
    shelves(row, val) {
      this.getAxios("/broadcast/standAndDown", {
        id: row.id,
        status: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // deleteRow(row) {
    //   this.delOpen = true;
    //   this.bid = row.id;
    // },
    // //不删除：
    // handleCancel() {
    //   this.delOpen = false;
    // },
    // handleOk() {
    //   this.getAxios("/broadcast/delete", {
    //     bid: this.bid,
    //   }).then((res) => {
    //     if (res.success) {
    //       this.$message.success(res.message);
    //       this.getList();
    //       this.delOpen = false;
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   });
    // },
    getList() {
      this.postAxios("/broadcast/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        broadcast: {
          type: this.searchData.type,
          title: this.searchData.title,
          zhaiyao: this.searchData.zhaiyao,
        },
      }).then((res) => {
        if (res.success) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    clearList() {
      this.searchData = {};
      this.getList();
    },
    onClose() {
      this.detailVisibile = false;
      this.changeVisibile = false;
      this.getList();
    },
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.wrapper {
  width: 95%;
  height: auto;
  margin: 20px auto;
}
.done {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>